module.exports = __webpack_public_path__ + "static/media/iw.2d7ed5d5.svg";